export default "__VITE_ASSET__CqzJBFUl__"